// extracted by mini-css-extract-plugin
export default {"modal":"Nr","topline":"Or","img":"Pr","textcontents":"Qr","heading":"Rr","copy":"Sr","link":"Tr","close":"Ur","modalinner":"Vr","container":"Wr"};
    if(module.hot) {
      // 1715091669563
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  